import React from 'react'
import { Tooltip } from 'antd'

// styles
import './title-subtitle.scss';

const TitleSubtitle = (props) => {

  let title = props.data[props.title];
  let subtitle = props.data[props.subtitle];

  return (
    <div className="title-subtitle-cell-renderer-container">
      <Tooltip title={title}>
        <div className="title">{title}</div>
      </Tooltip>
      <div className="subtitle">{subtitle}</div>
    </div>
  );
};

export default TitleSubtitle;